import { parse } from "@refinitiv-ui/utils/date.js";

export default {
  getLastSaturday() {
    let d = new Date();
    d.setUTCDate(d.getUTCDate() - (d.getUTCDay() + 1));
    this.selectedDate = d.toJSON().slice(0, 10);
    d.setUTCDate(d.getUTCDate() + 6);
    if (d.getTime() < new Date().getTime()) {
      this.todayDate = d.toJSON().slice(0, 10);
    } else {
      this.todayDate = new Date().toJSON().slice(0, 10);
    }
    const datePicker = document.getElementById("datePicker");
    datePicker.filter = function (date) {
      return parse(date).getUTCDay() % 7;
    };
    let d2 = new Date();
    d2.setUTCDate(d2.getUTCDate() - (d2.getUTCDay() + 1));
    this.maxDate = d2.toJSON().slice(0, 10);
    d2.setUTCDate(d2.getUTCDate() - 28);
    this.minDate = d2.toJSON().slice(0, 10);
  },
};
